import { Component } from '@angular/core';

@Component({
  selector: 'app-no-edit-role',
  templateUrl: './no-edit-role.component.html',
  styleUrls: ['./no-edit-role.component.scss'],
})
export class NoEditRoleComponent {}
